module.exports = __webpack_public_path__ + "static/media/logo.75dc11e2.png";